import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/login.jpg'


const _hoisted_1 = { class: "m-auto m-1230" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "mw-480 ms-lg-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-lg-6 d-none d-lg-block" }, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "rounded-3",
          alt: "login"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"d-inline-block mb-4\"><img src=\"/images/viavox_group_logotyp.png\" class=\"rounded-3 for-light-logo\" alt=\"login\"><img src=\"/images/viavox_group_logotyp.png\" class=\"rounded-3 for-dark-logo\" alt=\"login\"></div><h3 class=\"fs-28 mb-2\"></h3><p class=\"fw-medium fs-16 mb-4\"></p>", 3)),
          _createElementVNode("form", {
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]))
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "form-group mb-3" }, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary fw-medium py-2 px-3 w-100"
              }, [
                _createElementVNode("div", { class: "d-flex align-items-center justify-content-center py-1" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined text-white fs-20 me-2" }, " logout "),
                  _createElementVNode("span", null, "Выход")
                ])
              ])
            ], -1)
          ]), 32)
        ])
      ])
    ])
  ]))
}